import { appInsights } from '../../AppInsights';

export const trackEvent = (eventName, properties, measurements) => {
  if (appInsights?.trackEvent) {
    const eventData = {
      name: eventName,
      properties: {
        eventName,
        timestamp: new Date().toISOString(),
        ...properties,
      },
      measurements,
    };
    appInsights.trackEvent(eventData);
  }
};

export const trackException = (exception, properties) => {
  if (appInsights?.trackException) {
    const exceptionData = {
      exception,
      properties: {
        ...properties,
        timestamp: new Date().toISOString(),
      },
    };
    appInsights.trackException(exceptionData);
  }
};

export const trackMetric = (name, value, properties) => {
  if (appInsights?.trackMetric) {
    const metricData = {
      name,
      average: value,
      properties,
    };
    appInsights.trackMetric(metricData);
  }
};

export { appInsights };
